export interface EditorQuickFiltersState {
  showOnlyChanged: boolean;
  showEmpty: boolean;
  showMissing: boolean;
  compact: boolean;
}

export interface TranslationRowModel {
  keyPath: string;
  values: string[];
  hasEmpty: boolean;
  hasMissing: boolean;
  hasChanged: boolean;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const collectLeafKeys = (data: Record<string, unknown>, prefix = ""): string[] => {
  return Object.entries(data).flatMap(([key, value]) => {
    const next = prefix ? `${prefix}.${key}` : key;
    if (isRecord(value)) {
      return collectLeafKeys(value, next);
    }
    return [next];
  });
};

export const getNestedValue = (keyPath: string, data: Record<string, unknown>): string => {
  const value = keyPath
    .split(".")
    .reduce<unknown>((acc, key) => (acc as Record<string, unknown>)?.[key], data);

  if (value === null || value === undefined) return "";
  return String(value);
};

export const isEmptyTranslation = (value: string) => value.trim().length === 0;
